import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
const FIRE_SVG = 'https://cdn.magicpatterns.com/uploads/dEyBYn517i7W4wsBNFXmsQ/Fire.svg';
const CROWN_SVG = 'https://cdn.magicpatterns.com/uploads/5eEvgjwEK7nqKxy3jnejHp/Crown.svg';
const TARGET_SVG = 'https://cdn.magicpatterns.com/uploads/1beLpaVPEdVzyZgaPVQ47d/Direct_Hit.svg';
export function WhyChooseUs() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const {
    t
  } = useLanguage();
  const items = [{
    icon: FIRE_SVG,
    title: t('why.item1.title'),
    desc: t('why.item1.desc')
  }, {
    icon: CROWN_SVG,
    title: t('why.item2.title'),
    desc: t('why.item2.desc')
  }, {
    icon: TARGET_SVG,
    title: t('why.item3.title'),
    desc: t('why.item3.desc')
  }];
  return <section ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-323">
      <div className="relative z-10 mx-auto max-w-7xl" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="mb-12 sm:mb-14 text-center" data-id="element-325">
          <h2 className="text-3xl md:text-4xl" style={{
          color: 'var(--text-primary)'
        }} data-id="element-326">
            {t('why.title')}
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-3" data-id="element-327">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.15 + index * 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} className="rounded-2xl border p-6 sm:p-8 flex flex-col" style={{
          borderColor: 'var(--border)',
          backgroundColor: 'var(--bg-secondary)'
        }} data-id="element-328">
              {/* Icon with blue fill + scale-in animation */}
              <motion.div initial={{
            scale: 0,
            opacity: 0
          }} animate={isInView ? {
            scale: 1,
            opacity: 1
          } : {}} transition={{
            duration: 0.5,
            delay: 0.3 + index * 0.12,
            type: 'spring',
            stiffness: 200,
            damping: 15
          }} className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 mb-4" style={{
            backgroundColor: 'rgba(59, 130, 246, 0.15)'
          }} data-id="element-329">
                <img src={item.icon} alt="" className="w-7 h-7" draggable={false} data-id="element-330" />
              </motion.div>
              {/* Title */}
              <h3 className="text-base sm:text-lg mb-3" style={{
            color: 'var(--text-primary)'
          }} data-id="element-331">
                {item.title}
              </h3>
              {/* Description */}
              <p className="leading-relaxed text-sm sm:text-base" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-332">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}